import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import { IconArrowLeft } from "@tabler/icons-react"; 
import { useNavigate } from 'react-router-dom';

import styles from "./header.module.css";

export default function Header() {
    const navigate = useNavigate();
    return (
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Typography variant="h5" className={styles.title}>
            Bulk Storm Strategy
          </Typography>
          <Typography variant="subtitle1" className={styles.subtitle}>
            Create and send storm strategies to multiple regions
          </Typography>
        </div>
        <Button
          variant="outlined"
          onClick={() => navigate('/storm-strategy')}
          startIcon={<IconArrowLeft size={20} />}
          className={styles.backButton}
        >
          Back to Single Strategy
        </Button>
      </div>
    )
}